import { IconButton, styled } from "@mui/material";

export const ToolIconButton = styled(IconButton)({
	padding: 8,
});
